import { suggestedPrereadsText } from './InsightDocRow.locstring.json';
import FileInsightType from '../store/schema/FileInsightType';
import { ColorScheme } from 'owa-color-utils/lib/ColorScheme';
import { ControlIcons } from 'owa-control-icons';
import { Icon } from '@fluentui/react/lib/Icon';
import loc from 'owa-localize';
import * as React from 'react';

const styles = require('./InsightDocRow.scss');
const classNames = require('classnames');

export default function getInsightDocRowIcon(
    files: FileInsightType[],
    colorScheme: ColorScheme,
    iconClass: string
): JSX.Element {
    // Prioritize showing attachment icon if files contain attachment
    const fileContainsAttachment = files.filter(file => !!file.isMeetingAttachment).length > 0;
    const iconName = fileContainsAttachment ? ControlIcons.Attach : ControlIcons.Insights;
    const iconTitle = fileContainsAttachment ? loc(suggestedPrereadsText) : null;
    const textColor = colorScheme.accessibleText.msColorWhiteBackground;
    return (
        <Icon
            iconName={iconName}
            className={classNames(
                styles.insightsIcon,
                iconName === ControlIcons.Attach && styles.isAttachment,
                iconClass
            )}
            title={iconTitle}
            styles={{
                root: {
                    color: textColor,
                },
            }}
        />
    );
}
